import { TriggerCreate } from "@dots-projects/types";
import { v4 as uuidv4 } from "uuid";
import gif from "./verifyEmail.gif";

export const emailVerification = (
  workspace: string
): {
  trigger: TriggerCreate;
  title: string;
  description: string;
  gif: any;
} => {
  return {
    title: "Email Verification",
    description:
      "<p>Authenticate the members of your community! In this template Dots will add an email verification.</p>",
    gif,
    trigger: {
      name: "Email Verification",
      type: "button_click",
      platform: "discord",
      communityId: localStorage.getItem("guild-id") || "",
      authorUserId: localStorage.getItem("discord-id") || "",
      workspace,
      isDraft: true,
      configs: {
        messages: [
          {
            id: uuidv4(),
            buttonIds: [uuidv4()],
          },
        ],
        responseOnError: "Something went wrong, please try again!",
        $$editorButtonClickContent: {
          message: "Click below to verify your email!",
          channelId: "$channelId",
          buttonText: "Verify email",
          buttonEmoji: "✅",
          htmlMessage: "<p>Click below to verify your email!</p>",
        },
      },
      steps: [
        {
          type: "create_channel",
          name: "Create a private verificate email channel",
          id: "create_channel-ak39fj",
          configs: {
            channelName: "email-verification-{{user.username}}",
            userIds: ["{{user.id}}"],
            isPrivate: true,
            channelType: "onboarding",
          },
          isEntry: false,
          isGoal: false,
          transitions: [
            { targetStepId: "step1-0iNQy4" },
            { targetStepId: "step-delete-DwkbfQ" },
          ],
        },
        {
          id: "step-delete-DwkbfQ",
          type: "delete_channel",
          configs: {
            delaySeconds: 60 * 60 * 24,
            channelId: `{{create_channel-ak39fj.channelId}}`,
          },
          transitions: [],
        },
        {
          id: "step1-0iNQy4",
          type: "send_message",
          configs: {
            channelId: `{{create_channel-ak39fj.channelId}}`,
            message: `Please enter your email address to test out email verfication with Dots :)`,
          },
          transitions: [
            {
              targetStepId: "step-idle-kl9dn5",
            },
          ],
        },
        {
          id: "step-idle-kl9dn5",
          type: "idle",
          transitions: [
            {
              targetStepId: "step2-fmk3r48",
              when: {
                userResponse: {
                  type: "message",
                  channelId: `{{create_channel-ak39fj.channelId}}`,
                  userId: "{{user.id}}",
                  content: {
                    has: "email",
                  },
                },
              },
            },
            {
              targetStepId: "step-invalid-email-d73kfnc",
              when: {
                userResponse: {
                  type: "message",
                  channelId: `{{create_channel-ak39fj.channelId}}`,
                  userId: "{{user.id}}",
                  content: { hasnot: "email" },
                },
              },
            },
          ],
        },
        {
          id: "step-invalid-email-d73kfnc",
          type: "send_message",
          configs: {
            channelId: `{{create_channel-ak39fj.channelId}}`,
            message: `Hmm, that doesn't look like an email. Please try again.`,
          },
          transitions: [
            {
              targetStepId: "step-idle-kl9dn5",
            },
          ],
        },
        {
          id: "step2-fmk3r48",
          type: "verify_email",
          configs: {
            email: `{{step-idle-kl9dn5.response.content}}`,
            feedbackChannelId: `{{create_channel-ak39fj.channelId}}`,
            message: `Great, we've sent you an email. Note that the email may have been sent to junk or promotions. Please click the link inside and you'll get redirected here and we'll send a confirmation message!`,
          },
          transitions: [
            {
              targetStepId: "step3-kmrt62",
              when: "email-verified",
            },
          ],
        },
        {
          id: "step3-kmrt62",
          type: "send_message",
          configs: {
            channelId: `{{create_channel-ak39fj.channelId}}`,
            message: `Great, your email is verified!`,
          },
          transitions: [],
        },
      ],
    },
  };
};
